export default "__VITE_ASSET__Bnp4_M6d__"